import AbstractJobApplyForm from "./job_apply_forms";

class StepReview extends AbstractJobApplyForm {

  constructor(currentStepFormId) {
    super(currentStepFormId);

    this.initPage();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.$customFields !== 'undefined' && document.getElementById('job-apply-form-step-review')) {
    new StepReview('job-apply-form-step-review');
  }
});
